/**
 * Top Games Numbers Component
 * Shows ranking numbers on top games, composed from the 0-9 digit images
 */

import React from 'react';
import Image from '../../../../../../shared/components/Image';
import { MAX_TOP_GAMES } from '../../../../../../constants';
import { getTopGameNumberLayout } from './topGamesDigits';

import styles from './TopGamesNumbers.module.css';

interface TopGamesNumbersProps { index: string; }

const TopGamesNumbers: React.FC<TopGamesNumbersProps> = ({ index }) => {

  // Only show for the first MAX_TOP_GAMES games
  const numIndex = parseInt(index);
  if (numIndex > MAX_TOP_GAMES) {
    return null;
  }

  return (
    <div key={index} className={`${styles.TopGamesNumberContainer}`} data-last-digit={index.slice(-1)}>
      {getTopGameNumberLayout(numIndex).digits.map(({ digit, shift }) => (
        <Image
          key={shift}
          className={styles.digit}
          style={{ transform: `translateX(${shift * 100}%)` }}
          src={`/top_games_digits/${digit}`}
          alt={shift ? '' : `#${index}`}
          loading="eager"
        />
      ))}
    </div>
  );
};


export default TopGamesNumbers; // no memoize the component because dinamiclly changing data (index) can lead to ordering issues.
